import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";

// import DashboardPage from "./pages/DashboardPage";
// import ButtonsPage from "./pages/ButtonsPage";
// import CardsPage from "./pages/CardsPage";
// import ColorsPage from "./pages/ColorsPage";
// import BordersPage from "./pages/BordersPage";
// import AnimationsPage from "./pages/AnimationsPage";
// import OtherPage from "./pages/OtherPage";
// import ForgotPasswordPage from "./pages/ForgotPasswordPage";
// import RegisterPage from "./pages/RegisterPage";
// import PageNotFoundPage from "./pages/PageNotFoundPage";
// import BlankPage from "./pages/BlankPage";
// import ChartsPage from "./pages/ChartsPage";
// import TablesPage from "./pages/TablesPage";

import * as serviceWorker from "./serviceWorker";
import QrCodePage from "./pages/QrCodePage";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/qrcode" element={<QrCodePage />} />

      {/* <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/components/buttons" element={<ButtonsPage />} />
      <Route path="/components/cards" element={<CardsPage />} />
      <Route path="/utilities/colors" element={<ColorsPage />} />
      <Route path="/utilities/borders" element={<BordersPage />} />
      <Route path="/utilities/animations" element={<AnimationsPage />} />
      <Route path="/utilities/other" element={<OtherPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/page404" element={<PageNotFoundPage />} />
      <Route path="/blank" element={<BlankPage />} />
      <Route path="/charts" element={<ChartsPage />} />
      <Route path="/tables" element={<TablesPage />} /> */}
    </Routes>
  </BrowserRouter>
);

// Mendaftarkan service worker agar aplikasi menjadi PWA
serviceWorker.register();
